import { Locale } from './languages';

export const LANGUAGE_PARAM = 'lng';
export const BACK_URL_PARAM = 'back-url';
export const COUNTRY_CODE_HEADER = 'country-code';
export const X_URL_HEADER = 'x-url';
export const X_FORWARDED_HOST = 'x-forwarded-host';
export const HOST_HEADER = 'Host';
export const PATHNAME_HEADER = 'pathname';
export const NOT_ALLOWED_COUNTRY_HEADER = 'notAllowedCountry';
export const IS_BOT_HEADER = 'isBot';
export const OS_HEADER = 'os';
export const USER_IP = 'user-ip';
export const CF_COUNTRY_HEADER = 'cf-ipcountry';

export const MODAL_SEARCH_PARAM = 'modal';

export const DEMO_CURRENCY = 'FUN';
export const REF_PARAM = 'ref';
export const getSportsHref = (hostname: string, locale: string) => {
  const sportsLocale = locale === Locale.ENGLISH ? '' : `/${locale}`;

  return `https://sports.${hostname}${sportsLocale}`;
};
